import { toast } from 'vue-sonner';

export function usePortalPreviewMode() {
    const route = useRoute();
    const portalStore = useClientPortalStore();

    const previewClientId = computed(() => (
        portalStore.previewingAsClientId
        || (typeof route.query.asClientId === 'string' ? route.query.asClientId : null)
    ));
    const previewTenantId = computed(() => (
        typeof route.query.tenantId === 'string'
            ? route.query.tenantId
            : String(portalStore.currentTenantId || '')
    ));
    const isPreviewMode = computed(() => Boolean(previewClientId.value));
    const previewRouteQuery = computed(() => {
        if (!previewClientId.value) return undefined;

        return {
            asClientId: previewClientId.value,
            ...(previewTenantId.value ? { tenantId: previewTenantId.value } : {}),
        };
    });
    const previewQuerySuffix = computed(() => (
        previewRouteQuery.value
            ? `?${new URLSearchParams(previewRouteQuery.value).toString()}`
            : ''
    ));

    function withPreviewQuery(path: string): string {
        const normalizedPath = String(path || '').trim();
        const query = previewRouteQuery.value;
        if (!normalizedPath || !query) return normalizedPath;

        const isAbsolute = /^https?:\/\//i.test(normalizedPath);
        const url = new URL(normalizedPath, 'https://portal.vuey.local');
        for (const [key, value] of Object.entries(query)) {
            url.searchParams.set(key, value);
        }

        const resolved = `${url.pathname}${url.search}${url.hash}`;
        return isAbsolute ? `${url.origin}${resolved}` : resolved;
    }

    function allowPortalMutation(): boolean {
        if (!isPreviewMode.value) return true;
        toast.info('Preview mode is read-only.');
        return false;
    }

    return {
        previewClientId,
        previewTenantId,
        previewRouteQuery,
        previewQuerySuffix,
        withPreviewQuery,
        isPreviewMode,
        allowPortalMutation,
    };
}
